export default __webpack_public_path__ + "static/media/audience-network-native-banner-interstitial.482b344b.jpg";